import { Component } from '@angular/core';

import { MyApp } from '../../app/app.component';
import { UsuarioService } from '../../providers/usuario-service';
import { GestaoPcaService } from '../../providers/gestao-pca-service';

import { environment } from '../../environments/environment';
import { AmbienteService } from '../../providers/ambiente-service';
//import { NavController } from 'ionic-angular';
//import { ActionSheetController } from 'ionic-angular';

@Component({
  selector: 'menu',
  templateUrl: './menu-component.html'
})
export class MenuComponent {
  usuario: any;
  user: any;
  perfil: any;
  entidade: any;
  isJurisdicionado: boolean = false;
  usuarioLogado: boolean = false;

  versao: any;
  versaoApi: any;

  constructor(public app: MyApp,
    //private actionSheetCtrl: ActionSheetController,
    private gestaoPcaService: GestaoPcaService,
    private usuarioService: UsuarioService,
    private ambienteService: AmbienteService) {

    usuarioService.usuarioSetado.subscribe(dadosUsuario => {
      this.usuarioLogado = dadosUsuario.logado;
      this.usuario = dadosUsuario.usr;
      this.user = dadosUsuario;
    });

    // let pca = this.gestaoPcaService.getPCA();

    // if(pca){
    //   this.entidade = pca.jurisdicionado.dsJurisdicionado;
    // }

    this.versao = environment.VERSION;
    this.ambienteService.getVersaoApi().subscribe(versao => this.versaoApi = versao);
  }

  logout() {
    this.app.logout();
  }

  ajuda() {
    this.app.ajuda();
  }


  redirecionarParaGestaoPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    // let PCAATiva = this.gestaoPcaService.getPCA();

    // if (PCAATiva != undefined && PCAATiva.id != undefined) {
    let pagina = this.app.buscarPaginaCompleta(idSecaoPaginaGestaoPCA);
    this.app.openPage(pagina);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/menu-component/menu-component.ts